if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
        this.bindSwipe();
      }

      bindSwipe() {
        if (this.swipeBound) return;
        this.swipeBound = true;

        const container = this.querySelector('.product-media-modal__content');
        if (!container) return;

        const mql = window.matchMedia('(max-width: 749px)');
        let startX = 0;
        let startY = 0;
        let tracking = false;

        container.addEventListener(
          'touchstart',
          (event) => {
            if (!mql.matches || event.touches.length !== 1) return;
            startX = event.touches[0].clientX;
            startY = event.touches[0].clientY;
            tracking = true;
          },
          { passive: true }
        );

        container.addEventListener(
          'touchend',
          (event) => {
            if (!tracking) return;
            tracking = false;
            const touch = event.changedTouches[0];
            const deltaX = touch.clientX - startX;
            const deltaY = touch.clientY - startY;
            if (Math.abs(deltaX) < 50 || Math.abs(deltaX) < Math.abs(deltaY) * 1.5) return;
            this.goToAdjacentMedia(deltaX < 0 ? 1 : -1);
          },
          { passive: true }
        );
      }

      goToAdjacentMedia(direction) {
        const container = this.querySelector('.product-media-modal__content');
        if (!container) return;
        const items = Array.from(container.querySelectorAll(':scope > [data-media-id]'));
        const currentIndex = items.findIndex((element) => element.classList.contains('active'));
        if (currentIndex === -1 || items.length < 2) return;

        let nextIndex = (currentIndex + direction) % items.length;
        if (nextIndex < 0) nextIndex += items.length;

        items.forEach((element) => element.classList.remove('active'));
        items[nextIndex].classList.add('active');

        if (typeof window.pauseAllMedia === 'function') window.pauseAllMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
